import '@hapana/shared/utils/type-defs.util'

/** @type{Styles} */
export const styles = {
  fallbackContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  initialsText: {
    color: 'common.white',
    fontWeight: 700,
    lineHeight: 1,
    userSelect: 'none',
  },
}

export const getFallbackContainerStyle = (height, backgroundColor) => ({ height, backgroundColor })
